import { render, staticRenderFns } from "./DeliverableRow.vue?vue&type=template&id=3c3aabf3&scoped=true"
import script from "./DeliverableRow.vue?vue&type=script&lang=js"
export * from "./DeliverableRow.vue?vue&type=script&lang=js"
import style0 from "./DeliverableRow.vue?vue&type=style&index=0&id=3c3aabf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3aabf3",
  null
  
)

export default component.exports